<section id="section-report" class="container-fluid mt-1">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{inventoryEntryModel.inventoryEntryId}}" class="head col-12 col-lg-12">
                  <!-- Inventario  -->
                  <label id="t-inventario-{{inventoryEntryModel.inventoryEntryId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-inventario' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="inventario-{{inventoryEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()"> {{inventoryEntryModel.inventoryName}}</p>

                  <!--Nombre Sucursal -->
                  <label id="t-sucursal-{{inventoryEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-sucursal'
                    | formatLabelPipe : elementsLabel}}</label>

                  <p id="nombre-sucursal-{{inventoryEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{inventoryEntryModel.branchName}}</p>

                  <!--Dirección  -->
                  <label id="t-direccion-{{inventoryEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-direccion'
                    | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-{{inventoryEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{inventoryEntryModel.address}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-{{inventoryEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono' |
                    formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-{{inventoryEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{inventoryEntryModel.phone}}</p>

                  <!--Nombre Entrada Inv. -->
                  <p id="nombre-entrada-inventario-{{inventoryEntryModel.inventoryEntryId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'ENTRADA INVENTARIO Nro.'+ inventoryEntryModel.consecutive}}</p>

                  <!-- Fecha Entrada -->
                  <label id="t-fecha-entrada-inventario-{{inventoryEntryModel.inventoryEntryId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-fecha-entrada-inventario' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-entrada-inventario-{{inventoryEntryModel.inventoryEntryId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{inventoryEntryModel.dateEntry | date: 'dd/MM/yyyy'}}</p>

                  <!-- Proveedor  -->
                  <label id="t-proveedor-{{inventoryEntryModel.inventoryEntryId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-proveedor' | formatLabelPipe :
                    elementsLabel}}</label>

                  <p id="proveedor-{{inventoryEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{inventoryEntryModel.provider}}</p>

                  <!-- Concepto  -->
                  <label id="t-concepto-{{inventoryEntryModel.inventoryEntryId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-concepto' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="concepto-{{inventoryEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{inventoryEntryModel.conceptName}}</p>

                  <!-- Remisión  -->
                  <label id="t-remision-{{inventoryEntryModel.inventoryEntryId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-remision' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="remision-{{inventoryEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{inventoryEntryModel.remission}}</p>

                  <!-- Factura  -->
                  <label id="t-factura-{{inventoryEntryModel.inventoryEntryId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-factura' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="factura-{{inventoryEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{inventoryEntryModel.invoice}}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print id="detalle-entrada-inventario-{{ inventoryEntryModel.inventoryEntryId }}"
                  [columns]="columns" [data]="inventoryEntryModel.inventoryEntryDetails" [idMap]="idMap"
                  [documentId]="inventoryEntryModel.inventoryEntryId" [footerVisible]="true" [editFormat]="editFormat"
                  (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
              <!-- Observaciones -->
              <div id="foot-{{inventoryEntryModel.inventoryEntryId}}" class="foot mt-1 container-observations">
                <label id="t-observacion-entrada-inventario-{{inventoryEntryModel.inventoryEntryId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  *ngIf="inventoryEntryModel.observation">{{'t-observacion-entrada-inventario' |
                  formatLabelPipe : elementsLabel}}</label>
                <p id="observacion-entrada-inventario-{{inventoryEntryModel.inventoryEntryId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()" *ngIf="inventoryEntryModel.observation">
                  {{inventoryEntryModel.observation}}</p>

                <!-- Firma Revisado-->
                <p id="linea-firma-revisado-{{inventoryEntryModel.inventoryEntryId}}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-revisado-{{inventoryEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-linea-revisado' | formatLabelPipe : elementsLabel}}</label>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
                <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
                <p id="usuario-impresion" class="pe-4"> {{userAuthenticated}}</p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                    SAS. Nit.811.022.121-1. www.altos-soft.com</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>